import _ from 'lodash';
import update from 'immutability-helper';
import enums from '../common/utils/enums';
import qwPartners from '../common/clients/qwPartners';
import { getRegistrationApproval } from '../common/utils/approvals';
import { receiveCompanyDetails } from './companyDetails';
import { receiveInventory } from './inventory';
import { receiveServiceAreas, receiveTheatreLists } from './serviceAreas';
import { receiveCertificationDetails } from './certifications';
import { receiveAppliances } from './appliances';

const INITIALIZE = 'account/INITIALIZE';

const initialState = {
  user: null,
};

export function initializeUserAccount(user) {
  return { type: INITIALIZE, payload: user };
}

export function loadUserInfo() {
  return () => qwPartners.get('v1/users/me');
}

export function loadAccountData() {
  return (dispatch, getState) => {
    let approvals = getState().approvals;
    let registrationApproval = getRegistrationApproval(approvals);
    let account = getState().account;
    let partner = account.user && account.user.partner;
    _.extend(partner, { appliances: account.user && account.user.appliances });

    if (registrationApproval.status === enums.ApprovalStatus.NOT_SUBMITTED) {
      return;
    } else if (
      (registrationApproval.status === enums.ApprovalStatus.PENDING ||
        registrationApproval.status === enums.ApprovalStatus.NEEDS_MORE_INFO) &&
      !_.isEmpty(registrationApproval)
    ) {
      return dispatch(
        receiveAccountData(registrationApproval.registrationData, false),
      );
    } else if (
      registrationApproval.status === enums.ApprovalStatus.APPROVED &&
      !_.isEmpty(partner)
    ) {
      dispatch(receiveAccountData(partner, true));
    }
  };
}

export function receiveAccountData(account, isPartner) {
  return (dispatch) => {
    dispatch(receiveCompanyDetails(account));
    dispatch(receiveInventory(account));
    dispatch(receiveServiceAreas(account, isPartner));
    dispatch(receiveTheatreLists(account, isPartner));
    dispatch(receiveCertificationDetails(account));
    dispatch(receiveAppliances(account.appliances));
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case INITIALIZE:
      return update(state, { user: { $set: payload } });

    default:
      return state;
  }
}
